import FormattedMessage from 'I18n/components/FormattedMessage';
import { EmailIcon } from 'foundations-assets/icons/components/EmailIcon';
import { FoldedPaperIcon } from 'foundations-assets/icons/components/FoldedPaperIcon';
import { TasksIcon } from 'foundations-assets/icons/components/TasksIcon';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MeetingActionButton = ({
  icon: Icon,
  labelKey,
  onClick
}) => /*#__PURE__*/_jsx(View, {
  maxInlineSize: "200px",
  children: /*#__PURE__*/_jsx(Button, {
    use: "secondary",
    size: "xs",
    borderRadius: "full",
    width: "fit-content",
    onClick: onClick,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "100",
      children: [/*#__PURE__*/_jsx(Icon, {
        size: "200"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: labelKey
      })]
    })
  })
});
const MeetingRecapActionsSectionFormatter = ({
  section,
  callbacks
}) => {
  var _callbacks$MEETING, _callbacks$MEETING2, _callbacks$MEETING3;
  const {
    showDraftEmail,
    showAddNote,
    showAddTask
  } = section;
  if (!showDraftEmail && !showAddNote && !showAddTask) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "200",
    flexWrap: "wrap",
    children: [showDraftEmail && /*#__PURE__*/_jsx(MeetingActionButton, {
      icon: EmailIcon,
      labelKey: "chatspotComponents.sections.meetingRecapActionsFormatter.draftEmail",
      onClick: callbacks === null || callbacks === void 0 || (_callbacks$MEETING = callbacks.MEETING) === null || _callbacks$MEETING === void 0 ? void 0 : _callbacks$MEETING.onDraftEmail
    }), showAddNote && /*#__PURE__*/_jsx(MeetingActionButton, {
      icon: FoldedPaperIcon,
      labelKey: "chatspotComponents.sections.meetingRecapActionsFormatter.addNote",
      onClick: callbacks === null || callbacks === void 0 || (_callbacks$MEETING2 = callbacks.MEETING) === null || _callbacks$MEETING2 === void 0 ? void 0 : _callbacks$MEETING2.onAddNote
    }), showAddTask && /*#__PURE__*/_jsx(MeetingActionButton, {
      icon: TasksIcon,
      labelKey: "chatspotComponents.sections.meetingRecapActionsFormatter.addTask",
      onClick: callbacks === null || callbacks === void 0 || (_callbacks$MEETING3 = callbacks.MEETING) === null || _callbacks$MEETING3 === void 0 ? void 0 : _callbacks$MEETING3.onAddTask
    })]
  });
};
export default MeetingRecapActionsSectionFormatter;